import { parseTimestamp } from '@/util/zod/validators'
import { z } from 'zod'

// Based on the Pydantic model MedChronJobStatus
export enum MedChronJobStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  ERROR = 'ERROR',
  DONE = 'DONE',
}

// Integer version schema for medical chronology versions
export const MedChronVersionSchema = z.number().int().positive()

export const MedChronJobReadSchema = z.object({
  id: z.string().uuid(),
  artifact_id: z.string().uuid(),
  name: z.string(),
  file_sources: z.array(z.string()),
  user_file_ids: z.array(z.string()).default([]),
  status: z.nativeEnum(MedChronJobStatus),
  error_reason: z.string().nullable(),
  matter_id: z.string().uuid().nullable(),
  version: MedChronVersionSchema.nullable(),
  created_at: z.preprocess((val, ctx) => parseTimestamp(val, ctx), z.number()),
  updated_at: z.preprocess((val, ctx) => parseTimestamp(val, ctx), z.number()),
})
export type MedChronJobRead = z.infer<typeof MedChronJobReadSchema>

export const ListMedChronJobsResponseSchema = z.array(MedChronJobReadSchema)
export type ListMedChronJobsResponse = z.infer<typeof ListMedChronJobsResponseSchema>
